import React, { useState, useEffect } from 'react';

/**
 * Floating CloudWerx Icon - Links to husband's site
 * Small floating cloud logo with soft bobbing animation and hover glow
 */
const FloatingCloudWerxIcon = ({
  className = '',
  size = 80, // smaller than Crumb icon
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  // Nice delayed entrance
  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 1500); // slightly later than Crumb
    return () => clearTimeout(timer);
  }, []);

  const handleClick = () => {
    window.open('https://cloudwerxlab.com/', '_blank');
  };

  return (
    <div
      className={`fixed top-12 right-6 z-40 transition-all duration-500 ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
      } ${className}`}
    >
      {/* Tooltip on hover - positioned above the icon */}
      {isHovered && (
        <div className="absolute bottom-[calc(100%+8px)] right-0 transition-all duration-300 animate-fade-in">
          <div className="bg-gradient-to-r from-blue-500 to-cyan-500 text-white px-3 py-2 rounded-lg shadow-lg text-sm font-medium whitespace-nowrap">
            Click here to check out Hubby's site! ☁️
            <div className="absolute -bottom-1 right-4 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-blue-500"></div>
          </div>
        </div>
      )}

      {/* CloudWerx logo clickable area */}
      <button
        onClick={handleClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        title="Visit CloudWerx Lab - Ty's Developer Portfolio"
        aria-label="Visit CloudWerx Lab"
        className="
          relative p-0 m-0 border-none outline-none bg-transparent
          cursor-pointer select-none
          transform transition-all duration-300
          hover:scale-[1.08] active:scale-95
          animate-cloud-float
          focus:outline-none focus:ring-0
        "
        style={{
          width: size,
          height: size,
          filter: `drop-shadow(0 4px 8px rgba(0,0,0,0.25)) ${
            isHovered ? 'drop-shadow(0 0 20px rgba(59, 130, 246, 0.6))' : ''
          }`,
        }}
      >
        {/* CloudWerx logo image */}
        <img
          src="/assets/cloudwerx.png"
          alt="CloudWerx"
          className="w-full h-full object-contain pointer-events-none select-none"
          style={{
            filter: isHovered ? 'brightness(1.1) saturate(1.2)' : 'brightness(1)',
            transition: 'filter 0.3s ease',
          }}
        />
      </button>
    </div>
  );
};

export default FloatingCloudWerxIcon;

// Add custom CSS classes for cloud floating animation
const style = document.createElement('style');
style.textContent = `
  @keyframes cloud-float {
    0% {
      transform: translateY(0px) translateX(0px);
    }
    25% {
      transform: translateY(-4px) translateX(2px);
    }
    50% {
      transform: translateY(-2px) translateX(1px);
    }
    75% {
      transform: translateY(-6px) translateX(-1px);
    }
    100% {
      transform: translateY(0px) translateX(0px);
    }
  }

  @keyframes fade-in {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .animate-cloud-float {
    animation: cloud-float 6s ease-in-out infinite;
  }

  .animate-fade-in {
    animation: fade-in 0.3s ease-out;
  }
`;

// Only add the style if it doesn't exist
if (!document.querySelector('#cloudwerx-animations')) {
  style.id = 'cloudwerx-animations';
  document.head.appendChild(style);
}
